import { IconButton, Typography } from "@mui/material";
import { FaTrash } from "react-icons/fa6";

import { TLessonDocument } from "../../../../../@types";

export type TCloudLessonDocumentProps = {
	lessonDocument: TLessonDocument;
	onClickRemoveFile: (id: number) => void;
};

export function CloudLessonDocument({
	lessonDocument,
	onClickRemoveFile,
}: TCloudLessonDocumentProps) {
	return (
		<div className="lesson-media-item">
			<Typography flex={1} className="normal-text">
				{lessonDocument.name}
			</Typography>
			<IconButton
				className="icon-button"
				onClick={() => {
					onClickRemoveFile(lessonDocument.id);
				}}>
				<FaTrash />
			</IconButton>
		</div>
	);
}
